<template>
    <div>

        <div class="headView_top">
            <p class="applyTitle">项目名称：{{basicParams.project_name}}</p>
            <div class="headView_top_btn" v-if="allSubmit">
                <!-- showScore  -->
                <button type="button" @click="upShow('tips')">确认提交</button>
                <div class="btnTips">
                    <img src="../../assets/img/login/注释.png" style="width: 18px;height: 18px;">
                    <p>一旦提交，不可修改，请谨慎操作</p>
                </div>
            </div>
        </div>
        <div class="headClass">
            <p>项目类型：{{basicParams.project_type_name}}</p>
            <p>申请时间：{{basicParams.apply_start}}-{{basicParams.apply_end}}</p>
            <p>审核时间：{{basicParams.app_start}}-{{basicParams.app_end}}</p>
        </div>

        <div class="content_view">
            <div class="contentLeft">
                <p v-for="(item,index) in navList" :key="index" @click="changeTab(index)"
                   :class="navIndex === index?'tabActive':''">
                    {{item}}
                </p>
            </div>
            <div class="contentRight">

                <div v-show="navIndex === 0">

                    <p class="view_head">申报通知</p>
                    <!-- pdf -->
                    <div style="height: 650px;overflow-y: scroll">
                        <pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
                    </div>

                    <div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
                        <el-button :type="primary" @click="doReady" :disabled="disabled">{{btnContent}}</el-button>
                    </div>

                </div>

                <div v-show="navIndex === 1">
                    <p class="view_head">评选标准</p>
                    <!-- pdf -->
                    <div style="height: 650px;overflow-y: scroll">
                        <pdfVue v-if="selection_pdf_url" :pdf_url="selection_pdf_url"></pdfVue>

                    </div>

                    <div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
                        <el-button :type="primary" @click="doReady2" :disabled="disabled">{{btnContent}}</el-button>
                    </div>

                </div>

                <div v-show="navIndex === 2">
                    <p class="view_head">
                      申请书
                    </p>

                    <!-- 诚信企业 -->
                    <ChengXinCompany  :basicMsg="basicMsg" @basicInfo="getBasicInfo">
                    </ChengXinCompany>

                </div>

<!--                <div v-show="navIndex == 3">
                    <p class="view_head">资质</p>

                    &lt;!&ndash; 诚信企业 &ndash;&gt;
                    <ChengXinCompany :awardMsg="awardMsg" :isBasic="false" :project_app_num ="project_app_num"
                                  @awardInfo="getAwardInfo"></ChengXinCompany>

                </div>-->


                <div v-show="navIndex == 3">

                    <p class="view_head">评定表</p>
                    <el-form :model="valForm" :rules="valFormRules" ref="valRef">
                    <div>
                      <table border="1" class="newtable">
                        <thead>
                        <tr>
                          <th rowspan="2">项目</th>
                          <th rowspan="2">评价内容</th>
                          <th rowspan="2">评价标准</th>
                          <th rowspan="2">分值</th>
                          <th rowspan="2">评价计分</th>
                          <th colspan="3">评分</th>
                        </tr>
                        <tr>
                          <th>自评分</th>
                          <th>初评分</th>
                          <th>审定分</th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- 基本素质 -->
                        <tr>
                          <td rowspan="11">一、基本素质（30分）</td>
                          <td>1、资质及资格</td>
                          <td>具有企业法人营业执照、资质证书、安全生产许可证</td>
                          <td>6分</td>
                          <td>1、均在有效期内，计6分；<br>2、有一项不在有效期内，计0分。</td>
                          <td>
                            <el-form-item>
                              <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen1" :controls="false" ></el-input-number>
                            </el-form-item>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td rowspan="3">2、组织机构及制度建设</td>
                          <td>组织机构健全</td>
                          <td rowspan="3">9分</td>
                          <td rowspan="3">1、组织机构健全，计3分；<br>2、规章制度健全，计3分；<br>3、上述运行有效果，计3分。</td>
                          <td rowspan="3">
                            <el-form-item>
                              <el-input-number :max="9" :min="0" @change="calsum" v-model="valForm.fen2" :controls="false" ></el-input-number>
                            </el-form-item>
                          </td>
                          <td rowspan="3"></td>
                          <td rowspan="3"></td>
                        </tr>
                        <tr>
                          <td>规章制度健全</td>


                        </tr>
                        <tr>
                          <td>运行有效</td>


                        </tr>
                        <!-- 注意：这里只列出了部分行作为示例，完整表格需要继续添加剩余的行 -->

                        <!-- 管理体系认证 -->
                        <tr>
                          <td rowspan="3">3、管理体系认证</td>
                          <td>质量管理体系认证</td>
                          <td rowspan="3">9分</td>
                          <td rowspan="3">1、质量管理体系认证在有效期，计3分；<br>2、环境管理体系认证在有效期，计3分；<br>3、职业健康安全管理体系认证在有效期，计3分。</td>
                          <td rowspan="3"><el-form-item>
                            <el-input-number :max="9" :min="0" @change="calsum" v-model="valForm.fen3" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="3"></td>
                          <td rowspan="3"></td>
                        </tr>
                        <tr>
                          <td>环境管理体系认证</td>

                        </tr>
                        <tr>
                          <td>职业健康安全管理体系认证</td>

                        </tr>

                        <!-- 人员配置 -->
                        <tr>
                          <td rowspan="4">4、人员配置</td>
                          <td>管理和技术人员配置齐全、合理</td>
                          <td rowspan="4">6分</td>
                          <td rowspan="4">1、人员配置合理，计3分；<br>2、大专以上学历者符合要求，计1分；<br>3、一级注册建造师符合要求，计1分；<br>4、二级注册建造师符合要求，计1分。</td>
                          <td rowspan="4"><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen4" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="4"></td>
                          <td rowspan="4"></td>

                        </tr>
                        <tr>
                          <td>大专以上学历者大于人员总数的50%</td>
                        </tr>
                        <tr>
                          <td>上述人员中，一级注册建造师须符合岗位资格规定</td>
                        </tr>
                        <tr>
                          <td>上述人员中，二级注册建造师须符合岗位资格规定</td>
                        </tr>

                        <tr>
                          <td rowspan="5">二、经济指标 （30分）</td>
                          <td>1、企业净资产</td>
                          <td>符合资质的相应标准</td>
                          <td>6分</td>
                          <td>1、达到评价标准，计6分；<br>2、低于相应标准10%（含10%）以内，计3分；<br>3、低于相应标准10%以上，计0分。</td>
                          <td><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen5" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>2、工程结算收入</td>
                          <td>满足企业良性运行需求</td>
                          <td>6分</td>
                          <td>1、满足企业良性运行需求，计6分；<br>2、不能满足企业良性运行需求，计0分。</td>
                          <td><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen6" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>3、净资产增长率</td>
                          <td>增长率≧3%</td>
                          <td>6分</td>
                          <td>1、达到评价标准，计6分；<br>2、每降低1%，扣减1分；<br>3、小于0%，计0分。</td>
                          <td><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen7" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>

                          <td>4、资产负债率</td>
                          <td>负债率≦75%</td>
                          <td>6分</td>
                          <td>1、达到评价标准，计6分；<br>2、每增加5%，扣减1分；<br>3、负债率≥95%，计0分。</td>
                          <td><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen8" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>5、产值利润率</td>
                          <td>利润率≧1.5%</td>
                          <td>6分</td>
                          <td>1、达到评价标准，计6分；<br>2、每减少0.5%，扣减1分；<br>3、小于0%，计0分。</td>
                          <td><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen9" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>



                        <!-- 施工合同管理 -->
                        <tr>
                          <td rowspan="21">三、企业管理（40分）</td>
                          <td rowspan="2">1、施工合同管理</td>
                          <td>依法签订施工合同</td>
                          <td rowspan="2">5分</td>
                          <td rowspan="2">1、达到评价标准，计5分；<br>2、没有达到评价标准，计0分。</td>
                          <td rowspan="2"><el-form-item>
                            <el-input-number :max="5" :min="0" @change="calsum" v-model="valForm.fen10" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="2"></td>
                          <td rowspan="2"></td>
                        </tr>
                        <tr>
                          <td>施工合同管理履约率100%</td>
                        </tr>

                        <!-- 工程质量管理 -->
                        <tr>
                          <td rowspan="2">2、工程质量管理</td>
                          <td>有健全的质量管理体系和质量管理部门</td>
                          <td rowspan="2">6分</td>
                          <td rowspan="2">1、有健全的质量管理机构和专职的质量管理人员，该项计3分；<br>2、工程质量合格率100%，该项计3分。</td>
                          <td rowspan="2"><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen11" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="2"></td>
                          <td rowspan="2"></td>
                        </tr>
                        <tr>
                          <td>工程质量合格率100%</td>

                        </tr>

                        <!-- 绿色、安全施工管理 -->
                        <tr>
                          <td rowspan="2">3、绿色、安全施工管理</td>
                          <td>有健全安全生产的管理体系和专职的安全管理部门</td>
                          <td rowspan="2">6分</td>
                          <td rowspan="2">1、安全管理达到评价标准，计4分；<br>2、绿色施工管理达到标准，计2分。</td>
                          <td rowspan="2"><el-form-item>
                            <el-input-number :max="6" :min="0" @change="calsum" v-model="valForm.fen12" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="2"></td>
                          <td rowspan="2"></td>
                        </tr>
                        <tr>
                          <td>有健全的绿色施工管理体系</td>

                        </tr>

                        <!-- 材料设备采购管理 -->
                        <tr>
                          <td rowspan="2">4、材料设备采购管理</td>
                          <td>材料设备管理制度健全</td>
                          <td rowspan="2">4分</td>
                          <td rowspan="2">1、制度健全，计2分；<br>2、符合国家相关标准的要求，计2分。</td>
                          <td rowspan="2"><el-form-item>
                            <el-input-number :max="4" :min="0" @change="calsum" v-model="valForm.fen13" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="2"></td>
                          <td rowspan="2"></td>
                        </tr>
                        <tr>
                          <td>材料、设备符合国家相关标准的要求</td>

                        </tr>

                        <!-- 人力资源管理 -->
                        <tr>
                          <td rowspan="4">5、人力资源管理</td>
                          <td>依法与员工签订劳动合同，建立并实行员工绩效考核与激励机制</td>
                          <td rowspan="4">4分</td>
                          <td rowspan="4">1、达到每项评价标准，计1分</td>
                          <td rowspan="4"><el-form-item>
                            <el-input-number :max="4" :min="0" @change="calsum" v-model="valForm.fen14" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="4"></td>
                          <td rowspan="4"></td>
                        </tr>
                        <tr>
                          <td>职工继续教育经费，占企业工资总额的比率大于1.5%</td>

                        </tr>
                        <tr>
                          <td>依法与劳务队签订劳务分包合同，做到实名制管理</td>

                        </tr>
                        <tr>
                          <td>按时支付劳动者（含劳务队）报酬，按规定为劳动者（含劳务队）办理保险</td>

                        </tr>

                        <tr>

                          <td>6、标准化管理</td>
                          <td>具有符合现代化企业要求的技术和管理标准，实施标准化管理</td>
                          <td>3分</td>
                          <td>达到评价标准，计3分</td>
                          <td><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen15" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>
                          <td>7、企业发展战略</td>
                          <td>具有规划科学、目标明确、具有可操作性的中长期发展战略（规划）</td>
                          <td>3分</td>
                          <td>达到评价标准，计3分</td>
                          <td><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen16" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td rowspan="3">8、技术创新管理</td>
                          <td>有技术创新机构和专业人员</td>
                          <td rowspan="3">3分</td>
                          <td rowspan="3">1、有技术创新机构和专业人员，计1分；<br>
                            2、有技术创新规划或年度创新安排，计1分；<br>
                            3、有年度创新成果，计1分。</td>
                          <td rowspan="3"><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen17" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td rowspan="3"></td>
                          <td rowspan="3"></td>
                        </tr>
                        <tr>

                          <td>有技术创新规划或年度创新安排</td>


                        </tr>
                        <tr>

                          <td>有年度创新成果</td>


                        </tr>
                        <tr>
                          <td>9、研发经费投入（含科技成果奖励经费）</td>
                          <td>研发经费投入占企业总产值：特级企业≥0.5%；一级企业≥0.4%；二级企业≥0.3%</td>
                          <td>2分</td>
                          <td>1、达到评价标准，计2分；<br/>2、每降低0.2%，减1分。</td>
                          <td><el-form-item>
                            <el-input-number :max="2" :min="0" @change="calsum" v-model="valForm.fen18" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td rowspan="3">10、信息化建设管理</td>
                          <td>实现办公自动化（OA系统）</td>
                          <td  rowspan="3">4分</td>
                          <td  rowspan="3">1、使用OA系统，计2分；<br>
                            2、推广BIM和互联网+技术，计1分；<br>
                            3、使用企业网站，计1分。</td>
                          <td  rowspan="3"><el-form-item>
                            <el-input-number :max="4" :min="0" @change="calsum" v-model="valForm.fen19" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td  rowspan="3"></td>
                          <td  rowspan="3"></td>
                        </tr>
                        <tr>
                          <td>推广使用BIM和互联网＋技术</td>
                        </tr>
                        <tr>
                          <td>拥有企业（单位）网站</td>
                        </tr>

                        <tr>
                          <td rowspan="29">优良信息(加分项)</td>
                          <td rowspan="11">1、质量奖</td>
                          <td>中国建设工程鲁班奖</td>
                          <td rowspan="5">国家级4分</td>
                          <td  rowspan="5">1、总承包单位获得3个及以上，计4分；
                            <br>2、总承包单位获得1-2个，计3分；
                            <br>3、参建单位获得3个及以上，计2分；
                            <br>4、参建单位获得1-2个，计1分；
                            <br>5、累计得分不得超过4分。
                          </td>
                          <td  rowspan="5"><el-form-item>
                            <el-input-number :max="4" :min="0" @change="calsum" v-model="valForm.fen20" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td  rowspan="5"></td>
                          <td  rowspan="5"></td>
                        </tr>
                        <tr>
                          <td>中国土木工程詹天佑奖</td>
                        </tr>
                        <tr>
                          <td>中国土木工程詹天佑奖优秀住宅小区金奖</td>
                        </tr>
                        <tr>
                          <td>国家优质工程奖金奖、银奖</td>
                        </tr>
                        <tr>
                          <td>中国钢结构金奖</td>
                        </tr>
                        <tr>
                          <td>北京市建筑长城杯</td>
                          <td rowspan="6">省部级3分</td>
                          <td rowspan="6">
                            1、总承包单位获得3个及以上，计3分；<br>
                            2、总承包单位获得1-2个，计2分；<br>
                            3、参建单位获得奖项，计1分；<br>
                            4、获得区级优质工程奖，计1分；<br>
                            5、累计得分不得超过3分。
                          </td>
                          <td  rowspan="6"><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen21" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td  rowspan="6"></td>
                          <td  rowspan="6"></td>
                        </tr>
                        <tr>
                          <td>北京市市政基础设施长城杯</td>
                        </tr>
                        <tr>
                          <td>北京市建筑装饰优质工程奖</td>
                        </tr>
                        <tr>
                          <td>北京市安装工程优质奖</td>
                        </tr>
                        <tr>
                          <td>外省市省部级优质工程奖</td>
                        </tr>
                        <tr>
                          <td>北京市区级优质工程奖</td>
                        </tr>

                        <tr>
                          <td rowspan="3">2、安全奖</td>
                          <td>全国建设工程项目施工安全生产标准化工地</td>
                          <td >国家级3分</td>
                          <td >1、获得3个及以上，计3分；<br>
                            2、获得1-2个，计2分。</td>
                          <td><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen22" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>
                          <td>北京市绿色安全工地</td>
                          <td rowspan="2">北京市级2分</td>
                          <td rowspan="2">
                            1、获得样板工地2个及以上，计2分；<br>
                            2、获得样板工地1个，计1分；<br>
                            3、获得绿色安全工地3个及以上，计2分；<br>
                            4、获得绿色安全工地1-2个，计1分；<br>
                            5、累计得分不得超过2分。
                          </td>
                          <td><el-form-item>
                            <el-input-number :max="2" :min="0" @change="calsum" v-model="valForm.fen28" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>
                          <td>北京市绿色安全样板工地</td>

                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>

                          <td rowspan="14">3、科技进步奖</td>
                          <td>国家科学技术奖</td>
                          <td rowspan="7">国家级3分</td>
                          <td  rowspan="7">
                            1、获得3个及以上，计3分；<br>
                            2、获得1-2个，计2分。
                          </td>
                          <td  rowspan="7"><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen23" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td  rowspan="7"></td>
                          <td  rowspan="7"></td>
                        </tr>
                        <tr><td>全国绿色建筑创新奖</td></tr>
                        <tr><td>华夏建设科学技术奖</td></tr>
                        <tr><td>全国市政金杯示范工程</td></tr>
                        <tr><td>住建部科技计划项目（装配式建筑示范项目、绿色施工科技示范项目）</td></tr>
                        <tr><td>国家级工法</td></tr>
                        <tr><td>工程建设国家标准、行业标准、团体标准</td></tr>

                        <tr>

                          <td>北京市科学技术奖</td>
                          <td rowspan="7">北京市级2分</td>
                          <td  rowspan="7">
                            1、获得3个及以上，计2分；<br>
                            2、获得1-2个，计1分。
                          </td>
                          <td  rowspan="7"><el-form-item>
                            <el-input-number :max="2" :min="0" @change="calsum" v-model="valForm.fen24" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td  rowspan="7"></td>
                          <td  rowspan="7"></td>
                        </tr>

                        <tr><td>北京市科技成果鉴定</td></tr>
                        <tr><td>北京市建筑业新技术应用示范工程</td></tr>
                        <tr><td>北京市建筑信息模型（BIM)技术应用示范工程</td></tr>
                        <tr><td>北京市级工法</td></tr>
                        <tr><td>工程建设地方标准</td></tr>
                        <tr><td>工程造价地方标准（参与）</td></tr>


                        <tr>

                          <td>
                            4、社会责任信息
                          </td>
                          <td>
                            公益活动：向社会捐赠、捐献、扶困、义工等；或完成省、直辖市（含）以上下达的援建抢险救灾等任务（有证明、报道、收据、照片）
                          </td>
                          <td>
                            3分
                          </td>

                          <td>
                            有收据、含有企业名称的文件、报道、照片等证明文件，计3分
                          </td>
                          <td><el-form-item>
                            <el-input-number :max="3" :min="0" @change="calsum" v-model="valForm.fen25" :controls="false" ></el-input-number>
                          </el-form-item></td>
                          <td></td>
                          <td></td>

                        </tr>

                        <tr>
                          <td rowspan="2">
                            不良信息(减分项）
                          </td>
                          <td rowspan="2">
                            处罚
                          </td>
                          <td>
                            国家企业信用信息公示系统公示的处罚信息
                          </td>

                          <td>
                          </td>

                          <td rowspan="2">
                            3次处罚信息扣1分，不满3次扣0.5分，扣分无上限（同一处罚不重复扣分）
                          </td>
                          <td>
                            <el-form-item>
                              <el-input-number :max="0" :min="-10000" @change="calsum" v-model="valForm.fen26" :controls="false" ></el-input-number>
                              <p style="font-size: 12px;line-height: 18px;color: red">此分数为扣分项，请填写负数，如无处罚，请填写“0”</p>
                            </el-form-item>
                          </td>
                          <td></td>
                          <td></td>

                        </tr>

                        <tr>
                          <td>信用中国公布的处罚信息</td>
                          <td></td>
                          <td> <el-form-item>
                            <el-input-number :max="0" :min="-10000" @change="calsum" v-model="valForm.fen27" :controls="false" ></el-input-number>
                            <p style="font-size: 12px;line-height: 18px;color: red">此分数为扣分项，请填写负数，如无处罚，请填写“0”</p>
                          </el-form-item></td>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>
                          <td colspan="5" style="text-align: center !important;">
                            总计
                          </td>
                          <td>{{totalpoint}}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>

                        </tbody>
                      </table>


                        <!--<table class="gridtable">
                            <tbody>
                            <tr>
                                <th colspan="2">项目</th>
                                <th>自评分</th>
                            </tr>
                            <tr>
                                <td colspan="2">基本素质(30分)</td>
                                <td><el-input v-model="pdbForm.basic_quality" type="number" max="30" @change="calsum"></el-input></td>
                            </tr>
                            <tr>
                                <td rowspan="5">经济指标(30分)</td>
                                <td>企业净资产(6分)</td>
                                <td><el-input v-model="pdbForm.net_assets" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>
                                <td>工程结算收入(6分)</td>
                                <td><el-input v-model="pdbForm.project_settle_income" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>

                                <td>净资产增长率{{levelOne.growth_rate}}%(6分)</td>
                                <td><el-input v-model="pdbForm.growth_rate" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>

                                <td>资产负债率{{levelOne.liability_ratio}}%(6分)</td>
                                <td><el-input v-model="pdbForm.liability_ratio" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>
                                <td>产值利润率{{levelOne.profit_rate}}%(6分)</td>
                                <td><el-input v-model="pdbForm.profit_rate" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>
                                <td colspan="2">企业管理(40分)</td>
                                <td><el-input v-model="pdbForm.enp_management" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>
                                <td rowspan="2">市场信用（20）</td>
                                <td>优良信息</td>
                                <td><el-input v-model="pdbForm.good_msg" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>
                                <td>负数或是0</td>
                                <td><el-input v-model="pdbForm.bad_msg" @change="calsum" type="number"></el-input></td>
                            </tr>
                            <tr>
                              <td colspan="2">总分</td>
                              <td><el-input :value="totalpoint" type="number"></el-input></td>
                            </tr>
                            </tbody>
                        </table>-->
                    </div>

                    <div class="uploadBtn">
                        <el-button type="primary" @click="savePdbForm">保存</el-button>
                    </div>
                    </el-form>
                </div>

                <div class="uploadContent" v-show="navIndex === 4">

                    <div>
                        <div class="uploadHead" @click="upShow('muban')">
                            <img src="../../assets/img/main/muban.png" style="width: 20px;height: 20px;">
                            <p>模板下载</p>
                        </div>
                        <p class="view_head">资料上传</p>

                         <div style="display: flex;justify-content: flex-end">
                            <img  src="@/assets/img/main/download.png" style="width: 20px;height: 20px;">
                            <p  @click="downLoadFile" style="margin-right: 20px;">导出申请书</p>
                          </div>

                        <div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
                            <div class="uploadList_head">
                                <p><span v-if="index ==0 ||index ==2||index ==3||index ==4||index ==6||index ==10" style="color: red">*</span>{{item}}</p>
                                <div class="head_list">

                                    <img v-if="uploadData.tips[index].length==0" src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">
                                    <p v-if="uploadData.tips[index].length==0" @click="upShow('upload',index)">点击上传</p>
                                </div>
                            </div>
                            <div class="uploadList_mid" style="display: block">
                                <p v-if="uploadData.tips[index].length==0">{{uploadData.tips[index]}}</p>
                                <div v-if="uploadData.tips[index].length!=0" v-for="(item3,index3) in uploadData.tips[index]" :key="index3" style="display: block">
                                  <p @click="upShow('upload',index)"> {{item3}} <img src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">点击上传</p>
                                </div>
                            </div>
                            <div class="uploadList_bot">
                                <div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
                                     @click="showPriv(item)">
                                    <p>{{item.name?item.name:item.data_name}}</p>
                                    <img src="../../assets/img/login/cuowu.png" @click.stop="deleteUpload(key,index)">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

<!--        <div class="uploadBtn" v-show="navIndex == 2">
            <el-button type="primary" @click="basicInfo">保存</el-button>
        </div>-->

        <div class="uploadBtn" v-show="navIndex == 4" style="display: flex;flex-flow: column;">
            <div class="content_btn">
                <p>资料上传后请点击保存</p>
            </div>
            <el-button type="primary" @click="setUploadFile">保存</el-button>
        </div>

        <!-- 弹窗 -->
        <addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>


    </div>
</template>

<script>
    // getUploadFile上传文件附件
    import {
        getManagerInfo,
        getProjectDetail,
        getWinningInfo,
        saveQua,
        sureSubmit,
        getApplyDetail,
        getUploadFile,
        getDataItem,
        getBasicA,
        setBasicProgram,
        setTeamBasicInfo,
        setAdvanceInfo,
        setAdvanceInfoCx,
        setBIMBasicInfo,
        setPersonInfo,
        saveEva,
    } from '../../api/moudles/manager.js'
    import {
        API_DOMAIN
    } from '../../api/api.js'
    import {
        vaildte
    } from '../../utils/validate.js'
    import pdfVue from './components/pdfVue.vue'
    import labelText from '../../components/table/labelText.vue'
    import labelInput from '../../components/table/labelInput.vue'
    import normalPicker from '../../components/table/normalPicker.vue'
    import normalSelect from '../../components/table/normalSelect.vue'
    import addDialog from './components/addDialog.vue'
    // 质量管理小组
    import qualityTeam from './components/qualityTeam.vue'
    // 先进企业
    import advanceEnter from './components/advancedEnterprise.vue'
    // 优秀项目经理
    import goodManager from './components/goodManager.vue'
    // 优秀建造师
    import goodConstructor from './components/goodConstructor.vue'
    // 优秀项目成果
    import goodResults from './components/goodResults.vue'
    // BIM
    import BIM from './components/BIM.vue'
    import ChengXinCompany from "./components/ChengXinCompany";

    export default {
        name: "creditEnterprise",
        components: {
            labelInput,
            labelText,
            addDialog,
            pdfVue,
            normalPicker,
            normalSelect,
            qualityTeam,
            advanceEnter,
            goodManager,
            goodConstructor,
            goodResults,
            BIM,
            ChengXinCompany
        },
        data(){
            return{
              valForm:{
                fen1:'', fen2:'', fen3:'', fen4:'', fen5:'', fen6:'', fen7:'', fen8:'', fen9:'', fen10:'', fen11:'', fen12:'', fen13:'', fen14:'', fen15:'', fen16:'', fen17:'', fen18:'', fen19:'', fen20:'', fen21:'', fen22:'', fen23:'', fen24:'', fen25:'', fen26:'', fen27:'', fen28:''
              },
              valFormRules:{
                fen1:[
                  {required:true,message:'请输入',trigger:'blur'}
                ]
              },
                makeShow:0,
                totalpoint:'',
                basicMsg: {},
                awardMsg: [],
                // 质量小组基本信息
                basicInfo_6: {},
                check: false,
                disabled: false,
                // 参建单位
                textarea:'',
                textarea2:'',
                oldAddList: [],
                addList: [
                    // 	{
                    // 	type: '',
                    // 	name: '',
                    // },
                ],

                pdbForm:{
                    basic_quality:'',
                    net_assets:'',
                    project_settle_income:'',
                    growth_rate:'',
                    liability_ratio:'',
                    profit_rate:'',
                    good_msg:'',
                    bad_msg:'',
                    enp_management:'',
                    project_app_num:'',

                },

                // 参建方式
                installList: [
                    [{
                        name: '建设单位',
                        code: '建设单位'
                    }, {
                        name: '设计单位',
                        code: '设计单位'
                    }, {
                        name: '监理单位',
                        code: '监理单位'
                    }, {
                        name: '其他施工单位',
                        code: '其他施工单位'
                    }]
                ],
                projectType: '',
                basicParams: {},
                navIndex: 0,
                newnavIndex: 0,
                primary:'primary',
                spanWidth: '180px',
                navList: [
                    "申报通知",
                    "评选标准",
                    "申请书",
                    "评定表",
                    "资料上传",
                ],
                // 基本信息的
                req_num_code: '',
                project_code: '',
                // 基本信息表单
                levelOne: {},
                // 优质安装工程
                levelThree: {
                    company_name: '',
                    contact_name: '',
                    dep: '',
                    cellphone: '',
                    phone: '',
                    project_name: '',
                    declared_project: '',
                    construc_enp: '',
                    use_enp: '',
                    design_enp: '',
                    supervise_enp: '',
                },
                // 基本信息表单
                formName: {

                    contacts_post: '联系人职位',
                    real_name: '姓名',
                    id_card: '身份证',
                    birth_date: '出生年月',
                    // project_code: '',
                    education: '学历',
                    join_work_time: '参加工作时间',
                    title: '职称',
                    major: '建造师专业',
                    level: '建造师等级',
                    req_num: '注册编号',
                    cellphone: '本人联系电话',
                    head_dep: '单位主管部门',
                    enp_contact: '单位联系人',
                    enp_contact_phone: '联系电话',
                    // continue_year: '最近一次教育年度',
                    // 优秀建造师
                    present_post: '职务',
                    project_name: '项目名称',
                    company_name: '单位名称',
                    contacts: '联系人',

                    headcount: '编制人数',
                    engineering: '项目部名称',
                    author: '编制人姓名',
                    // 优质安装工程
                    // company_name:'单位名称',
                    contact_name: '联系人',
                    dep: '所在部门',
                    // cellphone:'手机号',
                    // phone: '固定电话',
                    // project_name:'工程名称',
                    declared_project: '申报工程内容',
                    construc_enp: '建设单位',
                    use_enp: '使用单位',
                    design_enp: '设计单位',
                    supervise_enp: '监理单位',
                    // participating_units:'',
                    // 质量小组
                    declaration_unit: '申报单位',
                    unit_address: '单位地址',
                    group_name: '小组名称',
                    topic_name: '课题名称',
                    course_type: '课程类型',

                    contacts_cellphone: '联系人手机',
                    publisher: '发布人姓名',
                    publisher_phone: '发布人手机号',
                    post: '获奖工程所从事职务',
                    tellphone: '本人联系电话',
                    introduction: '小组简介',
                    // 先进企业
                    // company_name:'',
                    // contacts:'',
                    // contacts_phone:'',
                    output_value: '总产值',
                    contract_amount: '合同额',
                    liability_ratio: '资产负债率',
                    profit_rate: '产值利润率',
                    growth_rate: '净资产增长率',
                    // BIM
                    declarant_name: '申报人姓名',
                    declarant_post: '申报人职位',
                    declarant_phone: '申报人电话',
                    achievement_name: '成果名称',
                    achievement_group: '成果分组',
                    contacts_name: '联系人姓名',
                    contacts_phone: '联系人电话',
                    contacts_address: '联系地址',
                    declarant_units: '申报单位',
                    leading_member: '团队成员',
                },
                // 获奖信息
                project_app_num: '',
                award_msg: ['质量获奖情况', '安全文明情况'],
                levelTwo: {
                    awardJson: [{}, {},{},{},{} ]
                },
                // 申报通知
                require_pdf_url: '',
                // 评选标准
                selection_pdf_url: '',
                btnContent:'我已阅读',
                totalTime:15,
                canClick: true, //添加canClick
                // 模板下载列表
                modelList: [],
                // 上传文件列表
                clickIndex: 0,
                uploadList: [],
                // 最终提交
                allSubmit: false,
                // 资料上传内容
                uploadData: '',
                // BIM申报的三个申报单位
                listArray: []
            }
        },
        created(){
            this.countDown()
            console.log(this.$route.params)

            if (!this.$route.params.projectCode) {
                this.$router.go(-1)
                return
            }
            // 获取pdf
            this.getProjectdetail(this.$route.params.projectCode)
            // 模板下载列表
            this.modelList = JSON.parse(this.$route.params.distribution_materials)
            // 获取项目类型字段
            const projectType = this.$route.params.type
            console.log('projectType', projectType)
            this.projectType = projectType

            // 绑定project_code
            this.levelOne.project_code = this.$route.params.projectCode
            this.project_code = this.$route.params.projectCode
            getDataItem({
                data: {
                    type: projectType
                },
                success: res => {
                    // console.log(res)
                    this.uploadData = res.data
                }
            })
        },

        methods : {
            safeParseFloat(value) {
              const number = parseFloat(value);
              return isNaN(number) ? 0 : number;
            },
            calsum(){
              console.log("valForm",this.valForm)

              this.totalpoint = [
                "fen1", "fen2", "fen3", "fen4", "fen5", "fen6", "fen7", "fen8", "fen9", "fen10", "fen11", "fen12", "fen13", "fen14", "fen15", "fen16", "fen17", "fen18", "fen19", "fen20", "fen21", "fen22", "fen23", "fen24", "fen25", "fen26","fen27","fen28"
              ].reduce((sum, key) => sum + this.safeParseFloat(this.valForm[key]), 0);
            },
            async savePdbForm(){
                if (!this.project_app_num) {
                  this.$message.error('请先提交申请书')
                  return
                }
                this.valForm.project_app_num = this.project_app_num

                this.$refs["valRef"].validate((valid) => {
                  if (valid) {
                    console.log("valForm",this.valForm)

                     saveEva({
                      data:this.valForm,
                      success:res=>{

                        console.log('res',res)

                        if (res.code === 200) {

                          this.$message({
                            type: 'success',
                            message: '保存成功!'
                          });

                        } else {
                          this.$message.error(res.msg)
                        }
                      }
                    })

                  } else {
                    console.log('error submit!!')
                    return false
                  }
                })

            },

            async personInfo(){
                await setPersonInfo({
                    data:{
                        content:this.textarea,
                        personal_resume2:this.textarea2,
                        project_app_num:this.project_app_num
                    },
                    success:res=>{
                        console.log('res',res)
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '保存成功!'
                            });
                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })
            },
            countDown() {
                if (!this.canClick) return  //改动的是这两行代码
                this.canClick = false
                this.btnContent =   '我已阅读' + '('+this.totalTime+'s)'

                this.disabled  = true

                let clock = window.setInterval(() => {
                    this.totalTime--
                    this.btnContent = '我已阅读' + '('+this.totalTime+'s)'
                    if (this.totalTime < 0) {
                        window.clearInterval(clock)
                        this.btnContent = '我已阅读'
                        this.disabled  = false
                        this.totalTime = 15
                        this.canClick = true  //这里重新开启
                    }
                },1000)
            },



            doReady(){
                this.makeShow++
                this.navIndex++

                this.countDown()

            },

            doReady2(){
                this.makeShow++
                this.navIndex++
            },

            // 下载pdf模板
            downLoadFile() {
                if (!this.project_app_num) {
                    this.$message.error('请先提交基本信息')
                    return
                }
                const url =
                    `${API_DOMAIN}/proapi/down/download-basic-msg?type=${this.projectType}&project_app_num=${this.project_app_num}&project_name=${this.basicParams.project_name}`
                window.open(url)
            },
            moreSelect(e) {
                this.listArray = e
            },
            // 优秀项目经理
            // 获取注册编号
            getreq_num_code(e) {
                this.req_num_code = e
            },
            // 获取质量小组获奖信息
            getAwardInfo(e) {
                const [id, name, value] = e
                if (value === '' || value === null) {
                    delete this.levelTwo.awardJson[id][name]
                } else {
                    this.levelTwo.awardJson[id][name] = value
                }
            },



            // 获取质量小组基本信息
            getBasicInfo(e) {
                this.levelOne = {
                    ...e
                }
                this.levelOne.project_code = this.project_code
                this.basicInfo()
            },
            // 保存的图片删除
            deleteUpload(key, index) {
                this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.uploadList[index].splice(key, 1)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 新增参建单位输入
            typeThreeInput(e, type, index) {
                if (type == '1') {
                    this.addList[index].type = e
                } else {
                    this.addList[index].name = e
                }
            },
            // 删除所在行
            // deleteList(index) {
            // 	if (this.addList.length === 1) {
            // 		this.$message.error(`至少填写一条参建信息`)
            // 		return
            // 	}
            // 	this.addList.splice(index, 1)
            // },
            // 删除行
            deleteList(index, type) {
                const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }
                if (type === '1') {
                    // 例旧信息
                    this.oldAddList.splice(index, 1)
                } else {
                    this.addList.splice(index, 1)
                }

            },
            // 新增参建单位
            addInstall() {
                this.addList.push({})
            },
            // 预览
            showPriv(e) {
                window.open(e.stored_path);
            },
            // 上传文件附件保存
            async setUploadFile() {
                let newArray = this.uploadList.filter(function(s) {
                    return s && s.length
                });
                if (!this.project_app_num) {
                    this.$message.error('请先提交申请书')
                    return
                }
                if (!newArray.length) {
                    this.$message.error('请先上传文件')
                    return
                }
                if (newArray.length < 2) {
                    this.$message.error('至少上传两条')
                    return
                }
                if(newArray.length < 10 && this.projectType === '0'){
                    this.$message.error('所有的内容必传哦')
                    return
                }


                if(newArray.length < 6 && this.projectType === '3'){
                    this.$message.error('所有的内容必传哦')
                    return
                }

                if(newArray.length < 5 && this.projectType === '2'){
                    this.$message.error('所有的内容必传哦')
                    return
                }

                if(newArray.length < 6 && this.projectType === '1'){
                    this.$message.error('所有的内容必传哦')
                    return
                }


                if (this.projectType === '2') {
                    if (!this.uploadList[1]) {
                        this.$message.error('项目管理成果论文必传')
                        return
                    }
                }

              if (this.projectType === '4') {
                if (!this.uploadList[0]
                    || !this.uploadList[2]
                    || !this.uploadList[3]
                    || !this.uploadList[4]
                    || !this.uploadList[6]
                    || !this.uploadList[10]
                )
                {
                  this.$message.error('存在必传项没上传，请检查')
                  return
                }
              }

                let dataJson = []
                this.uploadList.forEach((items, key) => {

                    items.forEach((item, index) => {
                        let data = {}
                        data['data_name'] = item.name ? item.name : item.data_name
                        data['type'] = key + 1
                        data['stored_path'] = item.url ? item.url : item.stored_path
                        dataJson.push(data)
                    })
                })
                const params = {
                    dataJson: dataJson,
                    project_app_num: this.project_app_num
                }
                await getUploadFile({
                    data: params,
                    success: res => {
                        // console.log(res)
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg + ',现在可以确认提交',
                                type: 'success'
                            });
                            this.allSubmit = true
                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })
            },
            //接受点击上传回穿
            submitSuccess(e) {
                if (this.uploadList[this.clickIndex]) {
                    let newList = [...this.uploadList[this.clickIndex], ...e]
                    this.$set(this.uploadList, this.clickIndex, newList)
                    return
                }
                this.$set(this.uploadList, this.clickIndex, e)
            },
            // 切换tab栏/
            changeTab(index) {
                //if(this.makeShow >1){
                    this.navIndex = index
                //}else{
                  //  this.$message.error('还没完成阅读')
               // }
            },
            // 获取必填警示
            requireSubmit(params, nameList) {
                //如果数据是对象形式
                let upString = []
                Object.keys(params).forEach((item, index) => {
                    if (params[item] == '' || params[item] == undefined || params[item] == null) {
                        if (nameList[item]) {
                            upString.push(item)
                        }
                    }
                })
                if (!upString.length) {
                    return false
                } else {
                    this.$message.error(`${nameList[upString[0]]}未填写`)
                    return true
                }
                // 如果数据是数组形式
            },

            // 获取项目明细
            async getProjectdetail(project_code) {
                await getProjectDetail({
                    data: {
                        project_code
                    },
                    success: (res) => {
                        // console.log('获取项目明细', res.data)
                        // 基本信息
                        if (res.data.basicMsg) {

                            this.makeShow = 2;

                            this.basicMsg = JSON.parse(res.data.basicMsg.basicjson)

                            this.textarea = this.basicMsg.personal_resume
                            this.textarea2 = this.basicMsg.personal_resume2

                            if (this.basicMsg.participating_units) {
                                this.oldAddList = JSON.parse(this.basicMsg.participating_units)
                            }
                            this.project_app_num = res.data.basicMsg.project_application_id

                            // 获奖信息需要数据
                            if (this.projectType === '0' || this.projectType === '1') {
                                let number = 0
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item, index) => {
                                    item.project_app_num = this.project_app_num
                                    item.pa_award_type = number++
                                    return item
                                })
                            }
                            if (this.projectType === '6') {
                                let number = 0
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                       index) => {
                                    item.project_app_num = this.project_app_num
                                    item.pa_award_type = number++
                                    return item
                                })
                            }
                            if (this.projectType === '3') {
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                       index) => {
                                    item.project_app_num = this.project_app_num
                                    // 先进企业
                                    if (index < 3) {
                                        item.pa_award_type = 0
                                    } else if (index > 2 && index < 6) {
                                        item.pa_award_type = 1
                                    } else if (index > 5 && index < 9) {
                                        item.pa_award_type = 2
                                    } else {
                                        item.pa_award_type = 3
                                    }
                                    return item
                                })
                            }
                        }
                        // 获奖信息
                        if (res.data.award_list) {
                            this.awardMsg = res.data.award_list
                            // console.log('获取项目明细', res.data.award_list)
                        }
                        // 文件上传
                        if (res.data.data_list) {
                            const uploadList = res.data.data_list
                            let newUploadList = []
                            uploadList.forEach((item, index) => {
                                newUploadList[Number(item.type) - 1] = []
                            })
                            uploadList.forEach((item, index) => {
                                newUploadList[Number(item.type) - 1].push(item)
                            })
                            this.uploadList = newUploadList
                        }

                        this.basicParams = res.data

                        if(typeof res.data.pa_evaluate != "undefined" && res.data.pa_evaluate != null){
                            this.valForm = JSON.parse(res.data.pa_evaluate.scorejson)
                            this.calsum()

                        }

                        // 申报通知
                        this.require_pdf_url = res.data.require_pdf_url
                        // 评选标准PDF
                        this.selection_pdf_url = res.data.selection_pdf_url
                    }
                })
            },
            // 提交获奖信息
            async getWinninginfo() {

                const params = {
                    awardJson: [...this.levelTwo.awardJson]
                }

                console.log(params)

               // return

                const newParams = params.awardJson

                if (!this.project_app_num) {
                    this.$message.error('请先提交申请书')
                    return
                }

                if (this.projectType === '0' || this.projectType === '6') {
                    // 优秀项目经理
                    for (let key in newParams) {
                        if (Object.keys(newParams[key]).length !== 5) {
                            this.$message.error(this.award_msg[key] + '未填写完整')
                            return
                        }
                    }
                } else if (this.projectType === '1') {
                    // 优秀建造师
                    for (let key in newParams) {
                        if (key === '0') {
                            // 5正常  3测试
                            // 4正常  2测试
                            // 5>3
                            if (Object.keys(newParams[key]).length !== 5) {
                                this.$message.error(this.award_msg[key] + '未填写完整')
                                return
                            }
                        } else {
                            const newarray = []
                            for (let key in newParams) {
                                if (key > 0) {
                                    // 0>2
                                    if (Object.keys(newParams[key]).length > 2) {
                                        this.check = true
                                        newarray.push(true)
                                    } else {
                                        newarray.push(false)
                                    }
                                }
                            }
                            // 一个true都没有，就是都没填，有一个true就说明填了，未知是否填写完整
                            if (newarray.indexOf(true) === -1) {
                                this.check = false
                            }
                            if (!this.check) {
                                this.$message.error('请至少选择一项进行填写')
                                return
                            }
                            // 第一个数只能是5或者2，其他数不能为3
                            // [[5,2,2],[5,4,2],[5,2,4],[5,4,4],[5,4,2],[2,4,2],[2,4,4],[2,2,4]]
                            const newNun = []
                            newParams.forEach((items, index) => {
                                if (index > 0) {
                                    newNun.push(Object.keys(items).length)
                                }
                            })
                            if ((newNun[0] === 5 || newNun[0] === 2) && (newNun[1] != 3) && (newNun[2] != 3)) {} else {
                                if (key === '1') {
                                    // 如果填写了
                                    if (Object.keys(newParams[key]).length) {
                                        // console.log(Object.keys(newParams[key]).length)
                                        if (Object.keys(newParams[key]).length !== 5) {
                                            this.$message.error(this.award_msg[key] + '未填写完整')
                                            return
                                        }
                                    }
                                } else {
                                    if (Object.keys(newParams[key]).length) {
                                        // console.log(Object.keys(newParams[key]).length)
                                        if (Object.keys(newParams[key]).length !== 4) {
                                            this.$message.error(this.award_msg[key] + '未填写完整')
                                            return
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else if (this.projectType === '3') {
                    // 先进企业
                    // 当处于先进企业状态下，0-2是质量获奖情况、3-5安全文明情况、6-8科技、成果、9-11信用建设
                    console.log(newParams)
                    for (let key in newParams) {
                        if (key < 6) {
                            // 5正常  3测试
                            // 4正常  2测试
                            if (Object.keys(newParams[key]).length !== 5) {
                                this.$message.error(this.award_msg[key] + '未填写完整')
                                return
                            }
                        } else {
                            if (Object.keys(newParams[key]).length !== 4) {
                                this.$message.error(this.award_msg[key] + '未填写完整')
                                return
                            }
                        }
                    }
                }


                params.project_app_num = this.project_app_num

                await saveQua({
                    data: params,
                    success: (res) => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            // 自定义判断获奖信息 题没提交成功
                        } else {
                            this.$message.error(res.msg)
                        }
                    },
                    fail: (err) => {
                        console.log(err)
                    }
                })
            },
            // 模板下载弹窗
            upShow(type, index) {
                this.clickIndex = index
                if (type === 'muban') {
                    const params = {
                        type,
                        download: this.modelList
                    }
                    this.$refs['download'].showAdd(params)
                } else if (type === 'tips') {
                    const params = {
                        type,
                        project_app_num: this.project_app_num
                    }
                    this.$refs['download'].showAdd(params)
                } else {

                    sessionStorage.setItem('dataUpload',index);

                    if (this.projectType === '2' && index === 1) {
                        const params = {
                            type,
                            project: true,
                        }
                        this.$refs['download'].showAdd(params)
                    } else {
                        const params = {
                            type,
                            project_app_num: this.project_app_num
                        }
                        this.$refs['download'].showAdd(params)
                    }
                }
            },

            // 基本信息申报
            async basicInfo() {
                const params = {
                    ...this.levelOne
                }
                if (this.project_app_num) {
                    params.project_app_num = this.project_app_num
                }
                // 验证各个工程的表单

                console.log("params",params)

                /*if (this.requireSubmit(params, this.formName)) {
                    return
                }*/

                // 诚信企业
                if(params.liability_ratio > 100 ||  params.profit_rate> 100||params.growth_rate > 100){
                  /*this.$message.error("企业经济指标各项不能超过百分百")
                  return*/
                }
                await setAdvanceInfoCx({
                    data: params,
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.project_app_num = res.data.project_app_num
                            this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                   index) => {
                                item.project_app_num = this.project_app_num
                                // 先进企业
                                if (index < 3) {
                                    item.pa_award_type = 0
                                } else if (index > 2 && index < 6) {
                                    item.pa_award_type = 1
                                } else if (index > 5 && index < 9) {
                                    item.pa_award_type = 2
                                } else {
                                    item.pa_award_type = 3
                                }
                                return item
                            })
                        } else {
                            if (res.data.project_app_num) {
                                this.project_app_num = res.data.project_app_num
                                let number = 0
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                       index) => {
                                    item.project_app_num = this.project_app_num
                                    // 先进企业
                                    if (index < 3) {
                                        item.pa_award_type = 0
                                    } else if (index > 2 && index < 6) {
                                        item.pa_award_type = 1
                                    } else if (index > 5 && index < 9) {
                                        item.pa_award_type = 2
                                    } else {
                                        item.pa_award_type = 3
                                    }
                                    return item
                                })
                                console.log(this.levelTwo.awardJson)
                            }
                            this.$message.error(res.msg)
                        }
                    }
                })

            },
            // 输入基本信息
            labelInput(e, name) {
                this.levelOne[name] = e
            },
            // 新增获奖信息
            labelInput3(e, name, id) {
                if (e) {
                    this.levelTwo.awardJson[id][name] = e
                } else {
                    delete this.levelTwo.awardJson[id][name]
                }

            }
        }
    }
</script>

<style scoped>
    /* 每个上传文件的样式 */
    .inner_upload {
        position: relative;
        min-height: 40px;
        margin: 0 10px;
        /* width: 100px; */
        /* overflow: scroll; */
    }

    .inner_upload p {
        color: #1890FF;
    }

    .inner_upload img {
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 0;
        width: 15px;
        height: 15px;
        cursor: pointer;
    }


    .headView_top_btn {
        position: relative;
        margin-right: 125px;
    }

    .btnTips {
        margin-top: 10px;
        display: flex;
        position: absolute;
        width: 350px;
        align-items: center;
    }

    .btnTips p {
        margin-left: 10px;
        font-size: 13px;
        color: #FE2c54;
    }

    /* 上传样式 */
    .uploadBtn {
        margin-top: 60px;
        margin-bottom: 60px;
        display: flex;
        margin-left: 41.5%;
    }

    .uploadBtn button {
        width: 140px;
    }

    .uploadHead {
        display: flex;
        position: absolute;
        align-items: center;
        left: 255px;
    }

    .uploadHead p {
        margin-left: 10px;
        color: #1890FF;
        cursor: pointer;
    }

    .uploadList {
        border: 1px solid #f0f0f0;
        width: 90%;
        margin-top: 30px;
        margin-left: 5%;
    }


    .uploadList_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 40px;
        padding: 0 40px 0 10px;
        line-height: 40px;
        font-size: 14px;
        flex-wrap: wrap;
        border-bottom: 1px solid #f0f0f0;
    }

    .uploadList_head p {
        text-align: left;
    }

    .head_list {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .head_list p {
        margin-left: 10px;
    }

    .head_list p:hover {
        color: #1890FF;
        text-decoration: underline;
    }

    .uploadList_mid {
        width: 90%;
        min-height: 30px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: flex-start;
    }

    .uploadList_mid p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        line-height: 24px;
        text-align: left;
        text-indent: 2em;
        padding: 10px;
    }

    .uploadList_bot {
        width: 70%;
        min-height: 30px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: flex-start;
    }

    .uploadList_bot p {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        color: #1890FF;
        text-decoration: underline;
        margin: 0 20px;
        cursor: pointer;
    }

    /* 上传样式 */
    .uploadContent {
        padding-bottom: 60px;
    }

    .inputList {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .titleLeft {
        margin-left: 50px;
    }

    .view_head {
        font-size: 18px;
        font-weight: 600;
        margin-top: 20px;
    }

    .midflex {
        display: flex;
        width: 90%;
        height: 50px;
        margin-left: 5%;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #eee;
    }

    .newAddBtn {
        width: 100%;
        display: flex;
        height: 70px;
        align-items: center;
        justify-content: center;
    }

    .headView {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
    }

    .headView_top {
        width: 1350px;
        display: flex;
        justify-content: space-between;
    }

    .headView_top button {
        width: 100px;
        height: 35px;
        background-color: #1890FF;
        color: white;
        line-height: 35px;
        cursor: pointer;
    }

    .applyTitle {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
    }

    .applyTitle {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
    }

    .headClass {
        display: flex;
        margin-top: 10px;
    }

    .headClass p {
        margin-right: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    /* 申报 */
    .content_view {
        margin-top: 20px;
        max-width: 1350px;
        min-height: 350px;
        /* min-height: 750px; */
        display: flex;
        border: 1px solid #f0f0f0;
    }

    .contentLeft {
        width: 200px;
    }

    .contentLeft p {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #333333;
        background-color: #fafafa;
        cursor: pointer;
    }

    .contentRight {
        width: 80%;
    }

    .tabActive {
        background: #e6f7ff !important;
        color: #6ea7ff !important;
        border-right: 2px solid #0077ff;
    }

    .content_btn {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        margin-bottom: 30px;
    }

    .content_btn p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FE2C54;
    }

    .content_btn button {
        width: 150px;
        margin-top: 40px;
        margin-left: 440px;
    }

    .specialView {
        width: 720px;
        display: flex;
        align-items: center;
    }

    .specialView input {
        margin-left: 20px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        letter-spacing: 1px;
        border-bottom: 1px solid #DBDBDB;
    }

    .specialView input::placeholder {
        color: #B5B5B5;
    }

    .dash_bottom {
        margin-top: 30px;
        margin-bottom: 20px;
        border-bottom: 1px solid #DBDBDB;
        margin-left: 120px;
        height: 1px;
        width: 81%;
    }

    /* gridtable */
     table.gridtable {
          font-family: verdana,arial,sans-serif;
           font-size:14px;
           color:#333333;
           border-width: 1px;
           border-color: #666666;
           border-collapse: collapse;
           margin: auto;
     }
     table.gridtable th {
         border-width: 1px;
         padding: 12px;
         border-style: solid;
         border-color: #666666;
         background-color: #dedede;
     }
      table.gridtable td {
          border-width: 1px;
          padding: 22px;
          border-style: solid;
          border-color: #666666;
          background-color: #ffffff;
      }

      table.gridtable .el-input__inner{
          border: none;
      }

     /* /gridtable */

    .newtable tr td{
      text-align: left;
      height: 60px;
      min-width: 50px;
    }
</style>